"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BbvaNotvalidError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.default = BbvaNotvalidError;
